<template>
  <div class="xiaobu-container" v-closeSelect="'window'">
    <el-form ref="queryForm" :model="queryParams" :inline="true" class="search-form clearfix">
      <el-form-item class="search-field fl five-per-row" label="出库单号" prop="outNo">
        <el-input v-model.trim="queryParams.outNo" clearable @keyup.enter.native="handleQuery"
          placeholder="请输入出库单号" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="出库类型" prop="outType">
        <el-select-dict :dictType="{type: 'OUT_TYPE', filters: '1,3'}" clearable placeholder="请选择出库类型" v-model="queryParams.outType"
          @dictChange="handleQuery"></el-select-dict>
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="商品名称" prop="goodsName">
        <el-input v-model.trim="queryParams.goodsName" clearable @keyup.enter.native="handleQuery"
          placeholder="请输入商品名称" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="商品编号" prop="goodsSn">
        <el-input v-model.trim="queryParams.goodsSn" clearable @keyup.enter.native="handleQuery"
          placeholder="请输入商品编号" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="单品编号"
        prop="spuSn">
        <el-input v-model.trim="queryParams.spuSn" clearable @keyup.enter.native="handleQuery" placeholder="请输入单品编号" />
      </el-form-item>

      <el-form-item class="search-field fl five-per-row" label="出售时间" prop="beginTime">
        <el-date-picker v-model="dateRange" value-format="yyyy-MM-dd HH:mm:ss" type="daterange" @change="handleQuery"
          range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>

      <el-form-item class="fr">
        <el-button plain @click="resetQuery">重 置</el-button>
        <el-button type="primary" @click="handleQuery">查 询</el-button>
      </el-form-item>
    </el-form>
    <div class="table-wrap">
      <div class="table-control-box">
      </div>
      <div class="table-box">
        <auto-height-table instanceHeight="328" ref="lendTable" :class="{ 'empty': list.length === 0 }" empty-text=" " v-loading="loading"
          :data="list">
          <el-table-column label="出库单号" prop="outNo" align="center" min-width="168px" >
            <template slot-scope="scope">
              <el-link v-if="mixinHasPermi(['inventory:out:list'])" type="primary" @click="handleGoOutList(scope.row.outNo)">{{ scope.row.outNo }}</el-link>
              <span v-else>{{ scope.row.outNo }}</span>
            </template>
          </el-table-column>
          <el-table-column-dict dictType="OUT_TYPE" prop="outType" label="出库类型" align="center" min-width="168px"></el-table-column-dict>
          <el-table-column label="商品信息" prop="goodsName" align="left" min-width="256px">
            <template slot-scope="scope">
              <div class="goods-info flex-c-s">
                <div class="goods-info-left">
                  <img @click.stop="mixinHandlePreview(scope.row.goodsImgs && scope.row.goodsImgs.split(','))"
                    :src="mixinGetImg(scope.row.goodsImgs && scope.row.goodsImgs.split(',')[0])" width="40px" height="40px"
                    alt="商品图片">
                </div>
                <div class="goods-info-right flex-c-c flex-col">
                  <div class="top">
                    <span class="label">名称：</span>
                    <span class="value">{{ scope.row.goodsName
                      }}</span>
                  </div>
                  <div class="bottom">
                    <span class="label">编号：</span>
                    <el-link v-if="mixinHasPermi(['inventory:statistics:list'])" @click="handleGo('goodsSn', scope.row.goodsSn)" type="primary" class="value">{{ scope.row.goodsSn }}</el-link>
                    <span v-else class="value">{{ scope.row.goodsSn }}</span>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="规格信息" prop="skuListStr" align="left"
            min-width="256px">
            <template slot-scope="scope">
              <div class="goods-info-right flex-c-c flex-col">
                <div class="top">
                  <span class="label">规格：</span>
                  <span class="value">{{ scope.row.skuListStr }}</span>
                </div>
                <div class="bottom">
                  <span class="label">编号：</span>
                  <el-link v-if="mixinHasPermi(['inventory:statistics:list'])" @click="handleGo('spuSn', scope.row.spuSn)" type="primary" class="value">{{ scope.row.spuSn }}</el-link>
                  <span v-else class="value">{{ scope.row.spuSn }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="客户名称" prop="customerInfo.customerName" align="center" min-width="108px" />
          <el-table-column label="销售数量" prop="outNumber" align="center" min-width="108px" />
          <el-table-column label="实际销售数量" prop="canUsedNumber" align="center" min-width="108px" >
          </el-table-column>
          <el-table-column label="实际总成本金额(元)" prop="totalCostPrice" align="center" min-width="168px" />
          <el-table-column label="实际总销售金额(元)" prop="totalSalesPrice" align="center" min-width="168px" />
          <el-table-column label="出售时间" prop="createTime" align="center" min-width="168px" ></el-table-column>
          <el-table-column label="已售出时间" prop="createTime" align="center" min-width="168px" >
            <template slot-scope="scope">
              {{ $dayjs().diff($dayjs(scope.row.createTime), 'day') }} 天
            </template>
          </el-table-column>
        </auto-height-table>

        <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize" @pagination="getList" />
      </div>
    </div>

    <div class="total-box flex-c-s">
      <div class="money-info flex-c-s">
        <div class="label">实际总成本金额：</div>
        <div calss="value">{{ totalCostPrice }}元</div>
      </div>
      <div class="money-info flex-c-s">
        <div class="label">实际总销售金额：</div>
        <div calss="value">{{ totalSalesPrice }}元</div>
      </div>
      <div class="kucun-info flex-c-s">
        <div class="label">实际总销售数量：</div>
        <div calss="value">{{ totalSalesNumber }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { statisticsApi } from "@/api"
export default {
  name: "inventorySalesManage",
  data() {
    return {
      dateRange: [],
      totalSalesNumber: 0,
      totalCostPrice: 0,
      totalSalesPrice: 0,
      //搜索条件参数
      queryParams: {
        outNo: "",
        goodsName: "", // 商品名称
        goodsSn: "", // 商品编号
        spuSn: "", // 单品编号
        pageNum: 1,
        pageSize: 10
      },
      list: [],
      loading: false,
      total: 0
    }
  },
  async created() {
    //获取列表
    this.getList()
  },
  methods: {
    // 跳转出库详情页
    handleGoOutList(outNo){
      this.$router.push({
        name: "inventoryOutManage",
        query: {
          outNo
        }
      })
    },  
    // 点击前往库存统计查询
    handleGo(key, value) {
      if (!this.mixinHasPermi(["inventory:statistics:list"])) {
        return
      }
      this.$router.push({
        name: "inventoryStatisticsManage",
        query: {
          [key]: value
        }
      })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = []
      this.mixinResetForm("queryForm")
      this.handleQuery()
    },
    /** 查询列表 */
    getList() {
      this.loading = true
      const params = JSON.parse(JSON.stringify(this.queryParams))
      statisticsApi
        .getSalesList(this.mixinAddDateRange(params, this.dateRange))
        .then((response) => {
          this.list = response.rows
          this.total = response.total
          this.totalSalesNumber = response.totalSalesNumber
          this.totalSalesPrice = response.totalSalesPrice
          this.totalCostPrice = response.totalCostPrice 
          this.loading = false
        })
        .catch((err) => {
          if (err?.name === "CanceledError") {
            return
          }
          this.loading = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.total-box {
  padding: 24px;
  font-size: 14px;
  background: #fff;
  border-radius: 4px;
  margin-top: 12px;

  .money-info {
    margin-right: 60px;
  }
}
</style>